import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  signal,
} from '@angular/core';
import { RouterModule } from '@angular/router';

import { SwiperOptions } from 'swiper/types/swiper-options';

import { Destination } from 'src/app/core/types/models/destination.model';
import { SwiperDirective } from 'src/app/shared/directives/swiper.directive';

import { CountryInfoService } from 'src/app/core/services/country-info.service';

import { CityCardMobileComponent } from '../city-card-mobile/city-card-mobile.component';

const CITY_LIST_SWIPER_OPTIONS: SwiperOptions = {
  slidesPerView: 1.2,
  spaceBetween: 16,
  autoplay: {
    delay: 10_000,
  },
  breakpoints: {
    375: {
      slidesPerView: 1.2,
      spaceBetween: 16,
    },
    524: {
      slidesPerView: 1.2,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 1.5,
      spaceBetween: 24,
    },
    1100: {
      slidesPerView: 2,
      spaceBetween: 32,
    },
  },
};

@Component({
  selector: 'app-city-list-mobile',
  templateUrl: './city-list-mobile.component.html',
  styleUrls: ['city-list-mobile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterModule, SwiperDirective, CityCardMobileComponent],
})
export class CityListMobileComponent implements OnInit {
  @Input() countryName: string = '';
  @Input() region: any = {};

  protected cities = signal<Destination[]>([]);
  protected readonly swiperOptions: SwiperOptions = CITY_LIST_SWIPER_OPTIONS;

  constructor(private readonly countryInfoService: CountryInfoService) {}

  ngOnInit() {
    this.generateCitiesByRegion();
  }

  private generateCitiesByRegion(): void {
    if (!this.region.citiesList$ && this.countryName) {
      this.region.citiesList$ = this.countryInfoService
        .getCountryInfo(`/${this.countryName}/${this.region.name}`)
        .subscribe((res) => {
          const { topDestinations, region } = res;
          const cities = topDestinations || region?.top_destinations || [];
          this.cities.set(cities.map((c: any) => new Destination(c)));
        });
    }
  }
}
